import { createContext, useContext } from "react";

import { ClientsSearchContextType } from "./ClientsSearchContextProvider.types.ts";

const ClientsSearchContext = createContext<ClientsSearchContextType>({} as ClientsSearchContextType);

export default ClientsSearchContext;

export const useClientsSearchContext = () => useContext(ClientsSearchContext);
